const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

/** Firmanın kariyer sayfası: /company/{slug} */
export const PUBLIC_COMPANY_PATH = '/company'

/** Kariyer sayfasında gösterilen firma bilgileri (CorporatePublicResponse) */
export interface IPublicCompanyModel {
  id: string
  slug: string
  name: string
  tagline?: string | null
  about?: string | null
  industry?: string | null
  employeeCount?: string | null
  country?: string | null
  website?: string | null
  linkedinUrl?: string | null
  termsUrl?: string | null
  privacyUrl?: string | null
  logoDocumentId?: string | null
  headerDocumentId?: string | null
}

/** MinIO'daki public görselin adresi (logo, header) */
export const publicDocumentUrl = (documentId?: string | null) =>
  documentId ? `${API_URL}api/v1/document/public/${encodeURIComponent(documentId)}` : undefined

/** Kullanıcının girdiği bağlantılar yalnızca http(s) ise link olarak basılır */
export const safeExternalUrl = (url?: string | null) =>
  url && /^https?:\/\//i.test(url) ? url : undefined

export const companyPath = (slug: string) => `${PUBLIC_COMPANY_PATH}/${slug}`

/** Sunucunun döndürdüğü kullanıcıya gösterilebilir hata mesajı */
export const apiErrorMessage = (error: any, fallback: string): string =>
  error?.response?.data?.friendlyMessage?.description || fallback
